/** Person directories use titled sections, each with its own people. */
import { DESCRIPTION_COPY_LIMITS, TITLE_COPY_LIMITS } from "../copy-policy";
import { PERSON_PORTRAIT_SLOT } from "../person-grid";
/** The two section ids the authored shape maps onto. Stable, never authored. */
export const PERSON_GRID_SECTION_ONE = "section-one";
export const PERSON_GRID_SECTION_TWO = "section-two";
/** The parts of one person an Editor fills in. Only the name is required. */
const PERSON_SCALAR_SLOTS = [
    { key: "name", label: "Name", type: "text" },
    { key: "role", label: "Role", type: "text" },
    {
        key: "bio",
        ...DESCRIPTION_COPY_LIMITS,
        label: "Bio",
        type: "textarea",
    },
];
/**
 * The sizes this block's heading may be set at, and the one it defaults to.
 *
 * ONE declaration, read twice: by the slot below (so the inspector offers these
 * three steps and marks L as the default) and by the renderer in `@diality/ui`
 * (so a stored step is resolved against the same list). Two copies would let the
 * menu offer a step the renderer had no size for.
 */
export const PERSON_GRID_HEADING_SCALE = {
    default: "l",
    steps: ["xl", "l", "m"],
    // The size applies to every section title, not a block-level text field.
};
export const personGridSchema = {
    componentId: "PersonGrid",
    scalarSlots: [
        { key: "eyebrow", label: "Eyebrow", type: "text" },
        {
            key: "headingSize",
            label: "Title size",
            type: "type-scale",
            scale: PERSON_GRID_HEADING_SCALE,
        },
    ],
    mediaSlots: [],
    repeatSlots: [
        {
            key: "sections",
            label: "Sections",
            itemLabel: "Section",
            scalarSlots: [
                {
                    key: "label",
                    ...TITLE_COPY_LIMITS,
                    label: "Title (required)",
                    type: "text",
                },
                {
                    key: "description",
                    ...DESCRIPTION_COPY_LIMITS,
                    label: "Description",
                    type: "textarea",
                },
            ],
            mediaSlots: [],
        },
        {
            key: "people",
            label: "People",
            itemLabel: "Person",
            scalarSlots: [
                {
                    key: "sectionId",
                    label: "Section",
                    type: "select",
                    optionsRepeat: "sections",
                },
                ...PERSON_SCALAR_SLOTS,
            ],
            mediaSlots: [PERSON_PORTRAIT_SLOT],
        },
        // Retained for editing older saved directories through the section editor.
        {
            key: "sectionOnePeople",
            label: "Section 1 people",
            itemLabel: "Person",
            scalarSlots: PERSON_SCALAR_SLOTS,
            // Built from the one declaration in `../person-grid`, so the size the
            // picker enforces and the size a stored reference is named by cannot drift.
            mediaSlots: [PERSON_PORTRAIT_SLOT],
        },
        {
            key: "sectionTwoPeople",
            label: "Section 2 people",
            itemLabel: "Person",
            scalarSlots: PERSON_SCALAR_SLOTS,
            mediaSlots: [PERSON_PORTRAIT_SLOT],
        },
    ],
};
//# sourceMappingURL=person-grid.js.map